import {Injectable} from '@angular/core';
import type {FlashMessagesAnchorComponent} from './flash-messages-anchor.component';
import {
    FlashMessage,
    FlashMessageOptions
} from './flash-message';

@Injectable()
export class FlashMessagesService {
    public flashMessagesAnchor: FlashMessagesAnchorComponent;

    public registerFlashMessagesAnchor(flashMessagesAnchor: FlashMessagesAnchorComponent): void {
        this.flashMessagesAnchor = flashMessagesAnchor;
    }

    public unregisterFlashMessagesAnchor(): void {
        this.flashMessagesAnchor = null;
    }

    public showFlashMessage(
        flashMessageOptions: FlashMessageOptions
    ): void {
        const flashMessage = new FlashMessage(flashMessageOptions);

        this.flashMessagesAnchor.addFlashMessage(flashMessage);
    }
}
